import React, { Fragment, useContext } from 'react';
import { Link } from '@reach/router';
import LogoutButton from '../../LogoutButton';
import { getUrl, APPS, getAppTokenName } from '@squirrellearningltd/go-shared-utils';
import ls from 'local-storage';
import { useApolloClient } from '@apollo/react-hooks';
import { APP_NAME } from '../../../services/constants'
import { AuthContext } from '../../../services/user/AuthProvider';
import cx from 'classnames';

const NavLinks = ({ onLogout, styles }) => {

    const client = useApolloClient();
    const { currentUser, setCurrentUser } = useContext(AuthContext);
    const token = ls(getAppTokenName(APP_NAME));

    const goToPortal = () => {
        ls.clear();
        setCurrentUser(null);
        client.writeData({
            data: {
                loggedIn: false
            }
        });
        window.location.href = `${getUrl(APPS.go_portal_pupil)}`;
    }

    const goToPortalRewards = () => {
        ls.clear();
        setCurrentUser(null);
        client.writeData({
            data: {
                loggedIn: false
            }
        });
        window.location.href = `${getUrl(APPS.go_portal_pupil)}/rewards`;
    }

    const goToPortalBoomer = () => {
        ls.clear();
        setCurrentUser(null);
        client.writeData({
            data: {
                loggedIn: false
            }
        });
        window.location.href = `${getUrl(APPS.go_portal_pupil)}/boomer`;
    }

    return (
        <Fragment>
            <ul className={styles.menuNav}>
                <li>
                    <button onClick={() => goToPortal()} className={cx(styles.menuNavItem, styles.menuNavItemHome)}>Home</button>
                </li>
                <li><Link to='/' className={cx(styles.menuNavItem, styles.menuNavItemWrite)}>Write</Link></li>
                {currentUser.school?.canAccessGoReadApp && (
                    <li><a href={`${getUrl(APPS.go_read_pupil)}?token=${token}`} className={cx(styles.menuNavItem, styles.menuNavItemRead)}>Read</a></li>
                )}

                <li>
                    <button onClick={() => goToPortalRewards()} className={cx(styles.menuNavItem, styles.menuNavItemRewards)}>Rewards</button>
                </li>
                {currentUser.boomerAvatarUrl ?
                    <li><button onClick={() => goToPortalBoomer()} className={cx(styles.menuNavItem, styles.menuNavItemBoomer)} style={{ backgroundImage: `url(${currentUser.boomerAvatarUrl}?v=${currentUser.updatedAt.replace(/\s/g, '')}` }}>Boomer</button></li> :
                    <li><button onClick={() => goToPortalBoomer()} className={cx(styles.menuNavItem, styles.menuNavItemBoomer)}>Boomer</button></li>
                }
            </ul>
            <div className={styles.menuNavExit}>
                {currentUser.isBoombassador && (<a href={`${getUrl(APPS.go_read_pupil)}/boombassador?token=${token}`} className={cx(styles.menuNavItem, styles.menuNavItemBoombassador)}></a>)}

                <LogoutButton onLogout={onLogout} classes={cx(styles.menuNavItem, styles.menuNavExitBtn)}>
                    Logout
                </LogoutButton>
            </div>
        </Fragment>
    )
}

export default NavLinks;
